import { render, staticRenderFns } from "./CvvModal.vue?vue&type=template&id=8bb5651c&"
import script from "./CvvModal.vue?vue&type=script&lang=ts&"
export * from "./CvvModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports